import { useState } from "react";

export const useRawInput = (initialValue = "") => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    onChange: (e) => setValue(e.target.value),
    setValue,
  };
};
